'use strict';

/**
 * Created by skoda02 on 10/16/16.
 */

var React = require('react');
var createReactClass = require('create-react-class');
var LocalizeMixin = require("../../localization/CommonLocalizationMixin");
var TransitionMixin = require('../../mixins/TransitionMixin');
var FacebookLoginApiHelper = require("../../lib/social/FacebookLoginApiHelper");

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin, TransitionMixin],
    handleEmailSignUpClick: function handleEmailSignUpClick() {
        if (this.props.handleEmailSignUpClick) {
            this.props.handleEmailSignUpClick();
        }
    },
    handleGoogleSignUpClick: function handleGoogleSignUpClick() {
        if (this.props.handleGoogleSignUpClick) {
            this.props.handleGoogleSignUpClick();
        }
    },
    handleFbSignUpClick: function handleFbSignUpClick() {
        this.props.showLoadingSpinner();
        FacebookLoginApiHelper.loginWithFacebook(this.props.handleFbSignUpClick, this.props.hideLoadingSpinner);
    },
    handleLoginClick: function handleLoginClick() {
        if (this.props.handleLoginClick) {
            this.props.handleLoginClick();
        } else {
            this.transitionTo('/login');
        }
    },
    removeErrorFromProps: function removeErrorFromProps(idx) {
        if (this.props.removeErrorFromProps) {
            this.props.removeErrorFromProps(idx);
        }
    },
    componentWillMount: function componentWillMount() {
        FacebookLoginApiHelper.loadFbLoginApi();
    },
    componentDidMount: function componentDidMount() {
        $(document).ready(function () {
            $('.carousel').carousel({
                interval: 4000
            });
        });
        this.refs.title.focus();
    },
    pauseCarousel: function pauseCarousel(e) {
        if (e.keyCode === 32) {
            e.preventDefault();
            $('.carousel').carousel('pause');
        }
    },
    render: function render() {
        var self = this;
        var desc11 = React.createElement(
            'p',
            { className: 'proposition-caption-sm' },
            this.getLocalizedText("value_proposition_caption_img1_text_1")
        );
        var desc12 = React.createElement(
            'p',
            { className: 'proposition-caption-sm' },
            this.getLocalizedText("value_proposition_caption_img1_text_2")
        );
        var desc21 = React.createElement(
            'p',
            { className: 'proposition-caption-sm' },
            this.getLocalizedText("value_proposition_caption_img2_text_1")
        );
        var desc22 = React.createElement(
            'p',
            { className: 'proposition-caption-sm' },
            this.getLocalizedText("value_proposition_caption_img2_text_2")
        );
        var desc31 = React.createElement(
            'p',
            { className: 'proposition-caption-sm' },
            this.getLocalizedText("value_proposition_caption_img3_text_1")
        );
        var desc32 = React.createElement(
            'p',
            { className: 'proposition-caption-sm' },
            this.getLocalizedText("value_proposition_caption_img3_text_2")
        );

        var emailSignUpText = this.getLocalizedText("value_proposition_sign_up_email");
        var fbSignUpText = this.getLocalizedText("value_proposition_sign_up_facebook");
        var googleSignUpText = this.getLocalizedText("value_proposition_sign_up_google");
        var signInText = this.getLocalizedText("value_proposition_login_text1");
        var login = this.getLocalizedText("value_proposition_login_text2");

        var errors = this.props.errors && this.props.errors.length > 0 ? this.props.errors.map(function (error, idx) {
            return React.createElement(
                'p',
                { key: "prop-err" + idx, className: 'bg-danger alert-danger alert' },
                error,
                React.createElement(
                    'span',
                    { 'aria-hidden': 'true', className: 'close', onClick: self.removeErrorFromProps.bind(self, idx) },
                    '\xD7'
                )
            );
        }) : [];

        return React.createElement(
            'div',
            { className: 'value-proposition' },
            React.createElement(
                'div',
                { className: 'container error-container', 'aria-live': 'polite' },
                errors
            ),
            React.createElement(
                'div',
                { className: 'value-proposition-container' },
                React.createElement(
                    'div',
                    { id: 'valuePropositionCarousel', className: 'carousel slide', onKeyDown: this.pauseCarousel },
                    React.createElement(
                        'ol',
                        { className: 'carousel-indicators' },
                        React.createElement('li', { 'data-target': '#valuePropositionCarousel', 'data-slide-to': '0', className: 'active' }),
                        React.createElement('li', { 'data-target': '#valuePropositionCarousel', 'data-slide-to': '1' }),
                        React.createElement('li', { 'data-target': '#valuePropositionCarousel', 'data-slide-to': '2' })
                    ),
                    React.createElement(
                        'div',
                        { className: 'sign-up-options' },
                        React.createElement(
                            'h1',
                            { ref: 'title', className: 'proposition-caption', tabIndex: '-1' },
                            this.getLocalizedText("value_proposition_caption")
                        ),
                        React.createElement(
                            'div',
                            { tabIndex: '0', role: 'button', className: 'email-sign-up', onClick: this.handleEmailSignUpClick },
                            React.createElement('img', { src: '/images/common/icons/ic_email_sign_up.png', alt: '' }),
                            emailSignUpText
                        ),
                        React.createElement(
                            'div',
                            { tabIndex: '0', role: 'button', className: 'fb-sign-up', onClick: this.handleFbSignUpClick },
                            React.createElement('img', { src: '/images/common/icons/ic_facebook_sign_up.png', alt: '' }),
                            fbSignUpText
                        ),
                        React.createElement(
                            'div',
                            { tabIndex: '0', role: 'button', className: 'google-sign-up', onClick: this.handleGoogleSignUpClick },
                            React.createElement('img', { src: '/images/common/icons/ic_google_sign_up.png', alt: '' }),
                            googleSignUpText
                        ),
                        React.createElement(
                            'div',
                            { className: 'sign-in' },
                            React.createElement(
                                'span',
                                { id: 'log-in-label' },
                                signInText
                            ),
                            React.createElement(
                                'a',
                                { 'aria-describedby': 'log-in-label', href: '#', onClick: this.handleLoginClick },
                                login
                            )
                        )
                    ),
                    React.createElement(
                        'div',
                        { className: 'carousel-inner', role: 'listbox', 'aria-live': 'polite' },
                        React.createElement(
                            'div',
                            { className: 'item active' },
                            React.createElement(
                                'div',
                                { className: 'fixed-ht' },
                                React.createElement('img', { className: 'value-prop-one', 'aria-hidden': 'true', src: '/images/common/davesdouble-1440w.jpg', alt: ' ' })
                            ),
                            React.createElement(
                                'div',
                                { className: 'carousel-caption' },
                                desc11,
                                desc12
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'item' },
                            React.createElement(
                                'div',
                                { className: 'fixed-ht' },
                                React.createElement('img', { className: 'value-prop-one', 'aria-hidden': 'true', src: '/images/common/hamburgerparty-1440w.jpg', alt: ' ' })
                            ),
                            React.createElement(
                                'div',
                                { className: 'carousel-caption' },
                                desc21,
                                desc22
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'item' },
                            React.createElement(
                                'div',
                                { className: 'fixed-ht' },
                                React.createElement('img', { className: 'value-prop-one', 'aria-hidden': 'true', src: '/images/common/saladparty-1440w.jpg', alt: ' ' })
                            ),
                            React.createElement(
                                'div',
                                { className: 'carousel-caption' },
                                desc31,
                                desc32
                            )
                        ),
                        React.createElement(
                            'a',
                            { className: 'left carousel-control', href: '#valuePropositionCarousel', tabIndex: '-1',
                                role: 'button', 'data-slide': 'prev' },
                            React.createElement('span', { className: 'glyphicon glyphicon-chevron-left', 'aria-hidden': 'true' }),
                            React.createElement(
                                'span',
                                { className: 'sr-only' },
                                'Previous'
                            )
                        ),
                        React.createElement(
                            'a',
                            { className: 'right carousel-control', href: '#valuePropositionCarousel', tabIndex: '-1',
                                role: 'button', 'data-slide': 'next' },
                            React.createElement('span', { className: 'glyphicon glyphicon-chevron-right', 'aria-hidden': 'true' }),
                            React.createElement(
                                'span',
                                { className: 'sr-only' },
                                'Next'
                            )
                        )
                    )
                )
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/valueProposition.js
// module id = 607
// module chunks = 0